import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import AccountsPage from './pages/AccountsPage';
import CustomersPage from './pages/CustomersPage';
import ProductsPage from './pages/ProductsPage';
import ProductDetailPage from './pages/ProductDetailPage';
import QuotesPage from './pages/QuotesPage';
import QuoteCreatePage from './pages/QuoteCreatePage';
import QuoteDetailPage from './pages/QuoteDetailPage';
import QuoteEditPage from './pages/QuoteEditPage';
import CatalogPage from './pages/CatalogPage';
import ProtectedRoute from './components/Common/ProtectedRoute';
import './styles/variables.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/accounts" element={<ProtectedRoute element={<AccountsPage />} allowedRoles={['manager']} />} />
        <Route path="/customers" element={<ProtectedRoute element={<CustomersPage />} allowedRoles={['manager', 'sales']} />} />
        <Route path="/products" element={<ProtectedRoute element={<ProductsPage />} allowedRoles={['manager', 'purchasing', 'sales']} />} />
        <Route path="/products/new" element={<ProtectedRoute element={<ProductDetailPage />} allowedRoles={['manager', 'purchasing']} />} />
        <Route path="/products/:id" element={<ProtectedRoute element={<ProductDetailPage />} allowedRoles={['manager', 'purchasing', 'sales']} />} />
        <Route path="/quotes" element={<ProtectedRoute element={<QuotesPage />} allowedRoles={['manager', 'sales']} />} />
        <Route path="/quotes/create" element={<ProtectedRoute element={<QuoteCreatePage />} allowedRoles={['manager', 'sales']} />} />
        <Route path="/quotes/:id" element={<ProtectedRoute element={<QuoteDetailPage />} allowedRoles={['manager', 'sales', 'purchasing']} />} />
        <Route path="/quotes/:id/edit" element={<ProtectedRoute element={<QuoteEditPage />} allowedRoles={['manager', 'sales']} />} />
        <Route path="/catalog" element={<ProtectedRoute element={<CatalogPage />} allowedRoles={['manager', 'purchasing', 'sales']} />} />
      </Routes>
    </Router>
  );
}

export default App;
